<div class="overlay" [hidden]="!isLoading">
    <p-progressSpinner [style]="{width: '60px', height: '60px'}" class="row" ></p-progressSpinner>
	<strong>{{loadingText}} ..</strong>
  </div>